module.exports = __webpack_public_path__ + "static/img/cheetah.b8852cf7.png";